<template>
  <page :styles="styles" :default-banner="false" class="print-customer-form">
    <template slot="banner">
      <div
        style="width: 100%; margin-bottom: 8px"
        class="align-center justify-center row-reversable px-4"
      >
        <div
          style="
            flex: 1;
            display: flex;
            font-size: 12px;
            flex-direction: column;
            justify-content: center;
          "
          class="align-start"
        >
          <img
            alt="SO"
            class="bill_logo"
            :src="branch_logo"
            style="width: 2cm; height: auto"
          />
        </div>
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <div class="text-xs-center align-end px-4 font-weight-bold">
            <h4>{{ LONG_APP_NAME }}</h4>
            <h4>Remittance LCTR Report</h4>
          </div>
        </div>
        <div
          style="
            flex: 1;
            display: flex;
            font-size: 12px;
            flex-direction: column;
            justify-content: center;
          "
          class="align-end"
        >
          <span>
            <span class="pcf-label">{{ $t("tr") }} </span>
            <span class="pcf-text">{{ transfer.number }}</span>
          </span>
          <span>
            <span class="pcf-label">{{ $t("date") }}: </span>
            <span class="pcf-text">{{ transfer.date }}</span>
          </span>
          <span>
            <span class="pcf-label">{{ $t("time") }}: </span>
            <span class="pcf-text">{{ transfer.time }}</span>
          </span>
        </div>
      </div>
    </template>

    <!-- <template slot="header">
      <th colspan="100%" class="justify-end py-0">
        <v-divider></v-divider>
      </th>
    </template> -->

    <template slot="body">
      <tr>
          <td
            colspan="100%"
            class="bill_color white--text pcf-label"
            style="font-size: 13px; font-weight: 600"
          >
            <span>
              {{ $t("sender_details") }}
            </span>
          </td>
        </tr>
        <tr >
          <td class="lr--text">
            <span class="pcf-label">{{ $t("reg_no") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.reg_id }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("full_name") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.name }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("father_name") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.father_name
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("nationality") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.nationality
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="lr--text">
            <span class="pcf-label">{{ $t(transfer.details.doctype) }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.docno }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("issue_date") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.issue_date }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("expire_date") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.expire_date
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.place_of_birth
            }}</span>
          </td>
        </tr>

        <tr>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.date_of_birth
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("occupation") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.occupation }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("phones") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.pretty_phones
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("relationship") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.relationship
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2"  class="lr--text">
            <span class="pcf-label">{{ $t("source_of_fund") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.source_of_fund
            }}</span>
          </td>
          <td colspan="2"  class="lr--text">
            <span class="pcf-label">{{ $t("purpose_of_transaction") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.purpose_of_transaction
            }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="4"  class="lr--text">
            <span class="pcf-label">{{ $t("address") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.address }}</span>
          </td>
        </tr>

        <!-- Receiver Details -->
        <tr>
          <td colspan="100%" class="white" style="padding-top: 5px"></td>
        </tr>
        <tr class="mt-2">
          <td
            colspan="100%"
            class="bill_color white--text  pcf-label"
            style="font-size: 13px; font-weight: 600"
          >
            <span>
              {{ $t("receiver_details") }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("full_name") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_name }}
            </span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("father_name") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_father_name }}
            </span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("nationality") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_nationality }}
            </span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("occupation") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_occupation
            }}</span>
          </td>
        </tr>

        <tr>
          <td class="lr--text">
            <span class="pcf-label"
              >{{ $t(transfer.details.receiver_doctype) }}:
            </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_docno
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("issue_date") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_issue_date
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("expire_date") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_expire_date
            }}</span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_place_of_birth }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_date_of_birth }}
            </span>
          </td>
          <td class="lr--text">
            <span class="pcf-label">{{ $t("phones") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.pretty_receiver_phones }}
            </span>
          </td>
          <td colspan="2" class="lr--text">
            <span class="pcf-label">{{ $t("address") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_address }}
            </span>
          </td>
        </tr>
        <!-- Transaction Details -->

        <tr>
          <td colspan="100%" class="white" style="padding-top: 5px"></td>
        </tr>
        <tr class="mt-2">
          <td
            colspan="100%"
            class="bill_color white--text  pcf-label"
            style="font-size: 13px; font-weight: 600"
          >
            <span>
              {{ $t("transaction_details") }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="lr--text">
            <span class="pcf-label">{{ $t("amount") }}: </span>
            <span class="pcf-text capitalize">
              {{
                transfer.amount
                  | currency({ symbol: smbl(transfer.currency_id, isRTL) })
              }}
              ({{ transfer.amount | toWord }})
            </span>
          </td>
          <td colspan="2" class="lr--text">
            <span class="pcf-label">{{ $t("commission") }}: </span>
            <span class="pcf-text capitalize">
              {{
                transfer.commission_amount
                  | currency({
                    symbol: smbl(transfer.commission_currency_id, isRTL),
                  })
              }}
              ({{ transfer.commission_amount | toWord }})
            </span>
          </td>
        </tr>
      <!-- <tr>
        <td colspan="1">
          <span class="pcf-label">{{ $t("rate") }}</span>
        </td>
        <td colspan="3">
          <span class="pcf-text capitalize">
            {{ transfer.rate }}
          </span>
        </td>
      </tr> -->
      <!-- <tr>
        <td colspan="1">
          <span class="pcf-label">{{ $t("exchange") }}</span>
        </td>
        <td colspan="3">
          <span class="pcf-text capitalize">
            {{
              transfer.exchanged
                | currency({ symbol: smbl(transfer.receiver_currency_id) })
            }}
            ({{ transfer.exchanged | toWord }}
            {{ smbl(transfer.receiver_currency_id) }})
          </span>
        </td>
      </tr> -->
      <tr>
        <td colspan="100%" class="white px-0 pt-3 pb-2 lr--text">
          <p>
            <strong class="pcf-label">{{ $t("description") }} : </strong
            ><span class="pcf-text">{{ transfer.description }}</span>
          </p>
        </td>
      </tr>
    </template>
  </page>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    transfer: {
      default: () => ({
        customer_id: null,
        buy_customer_id: null,
        buy_currency_id: null,
        sale_currency_id: null,
        sale_customer_id: null,
        number: 1000,
        amount: 1000,
        rate: 76,
        transferd_amount: null,
        transferr: "Extenral Person",
        type: "sale",
        date: null,
        time: null,
        description: "First transfer",
        details: {
          id: 1,
          transfer_id: 1,
          reg_id: "1000",
          name: "Mohmmad Ali",
          father_name: "Hassan",
          full_name: "1000 - Mohmmad Ali",
          doctype: "passport",
          docno: "P07878787878",
          nationality: "Afghan",
          issue_date: null,
          expire_date: null,
          place_of_birth: "Midan",
          date_of_birth: "2020-12-16",
          purpose_of_transaction: "Daily Usage",
          source_of_fund: "Daily Income",
          address: "Kabul, Share Naw",
          phones: ["07889898989", "08987222"],
          occupation: "Occupation",
          nature_of_business: null,
          created_at: "2020-12-17T07:25:08.000000Z",
          updated_at: "2020-12-17T07:25:08.000000Z",
          pretty_phones: "07889898989 - 08987222",
        },
      }),
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    items() {
      return this.dailyReport.items;
    },

    landscape() {
      return false;
    },

    styles() {
      if (this.landscape) return { "min-height": "200mm", width: "290mm" };
      return { "min-height": "auto", width: "200mm" };
    },
  },
  methods: {
    reset() {
      this.$router.go(-1);
    },
  },
};
</script>